import { render, staticRenderFns } from "./ConfigViewerToncoinBridge.vue?vue&type=template&id=4bed9ec4"
import script from "./ConfigViewerToncoinBridge.vue?vue&type=script&lang=js"
export * from "./ConfigViewerToncoinBridge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports